import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Audiencepoint() {
  return (
    <section
      className="audience_point p-100 text_white bg_green_color"
      style={{ background: "#000" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              Target <span style={{ color: "#E8E751" }}>Audience</span>
            </h2>
            <p>
              Point 2 Design targets celebrities who require a convenient and
              secure method for adding digital signatures to their orders. Thus,
              the exclusive audience benefits from the app's user-friendly
              features designed to enhance their order management experience.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center offset-xl-1 offset-lg-1"
          >
            <div className="banner_img">
              <StaticImage
                src="../../../images/case-studies/point2-design/audience.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={763}
                height={703}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Audiencepoint;
